import script from "./GenerationSettingsGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerationSettingsGrid.vue?vue&type=script&setup=true&lang=js"

import "./GenerationSettingsGrid.vue?vue&type=style&index=0&id=b37d5f12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b37d5f12"]])

export default __exports__